import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../services/axiosInstance";
import { route } from "../../services/apiRoutes";

// Initial state
const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
    generatedLink: "",
    masterData: {},
};

// Async thunk for creating voucher link
export const createVoucherLink = createAsyncThunk(
    "voucherLink/createVoucherLink",
    async (payload, thunkAPI) => {
        try {
            // payload contains firstName, lastName, contactNumber, email
            const res = await POST(route.CREATE_CP_VOUCHER_FORM, payload);
            if (res?.response?.success) {
                // Extract voucherFormUrl from API response
                return res.response.response.data.voucherFormUrl;
            } else {
                return thunkAPI.rejectWithValue(
                    res?.response?.errors || "Failed"
                );
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error?.response?.data || error.message
            );
        }
    }
);

export const getChannelPartnerById = createAsyncThunk(
  "voucherLink/getChannelPartnerById",
  async (linkId, thunkAPI) => {
    try {
      const res = await GET(`${route.GET_CHANNEL_PARTNER_BY_ID}?linkId=${linkId}`);

      if (res?.response?.success) {
        return res.response.response.data;
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.errors || "Failed to fetch channel partner"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

export const getMasterData = createAsyncThunk(
  "voucherLink/getMasterData",
  async (_, thunkAPI) => {
    try {
      const res = await GET(`${route.GET_MASTER_DATA}?key=residentialStatus`);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      }
      return thunkAPI.rejectWithValue(
        res?.response?.errors || "Failed to fetch master data"
      );
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

// Slice
const voucherLinkSlice = createSlice({
    name: "voucherLink",
    initialState,
    reducers: {
        clearVoucherLinkState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(createVoucherLink.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
                state.isSuccess = false;
            })
            .addCase(createVoucherLink.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.generatedLink = action.payload;
            })
            .addCase(createVoucherLink.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.payload;
            });
        
        builder
            .addCase(getChannelPartnerById.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
                state.isSuccess = false;
            })
            .addCase(getChannelPartnerById.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getChannelPartnerById.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.payload;
            });

        builder
            .addCase(getMasterData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getMasterData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.masterData = action.payload;
            })
            .addCase(getMasterData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.payload;
            });
    },
});

export const { clearVoucherLinkState } = voucherLinkSlice.actions;
export default voucherLinkSlice.reducer;
